/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecord {
    getFixupPrototypeFunction() { return ResourceRecord.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecord>): ResourceRecord {
        let obj = Object.assign(new ResourceRecord(), model);
        ResourceRecord.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecord>): ResourceRecord {
        if (!model) return null;
        return ResourceRecord.newInstance(<ResourceRecord> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecord) {
        if (!obj) return;

        models.ResourceRecord.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecord): boolean {
        Object.setPrototypeOf(obj, ResourceRecord.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of Resource Property
     */
    name: string;

    /**
     * Value of Property
     */
    value: string;

}
